import React from "react";
import { Trans } from "react-i18next";

const TranslatedString = (props) => {
  return <Trans i18nKey={props.children} {...props} values={props.subs} />;
};

export default TranslatedString;
